module.exports = __webpack_public_path__ + "img/equifax.ba94138c.jpg";